// Module
var code = "<workshop-instance-zoom-host></workshop-instance-zoom-host>";
// Exports
module.exports = code;